import { createSelector } from "@reduxjs/toolkit";

import { assert } from "../../../asserts/index.ts";
import type { NautilusDesignerState } from "../nautilusState.ts";

const contentLanguagesRawSelector = (state: Pick<NautilusDesignerState, "contentLanguages">) => state.contentLanguages;

export const contentLanguagesSelector = createSelector(contentLanguagesRawSelector, (contentLanguages) =>
  contentLanguages.slice().sort((a, b) => (b.isPrimary ? 1 : 0) - (a.isPrimary ? 1 : 0)),
);

export const languagesSelector = createSelector(contentLanguagesSelector, (contentLanguages) =>
  contentLanguages.map((cl) => cl.language),
);

export const availableLanguageCodesSelector = createSelector(languagesSelector, (languages) =>
  languages.map((language) => language.code),
);

export const primaryContentLanguageSelector = createSelector(contentLanguagesSelector, (contentLanguage) => {
  const primaryLang = contentLanguage.find((cl) => cl.isPrimary);
  assert(primaryLang, "No primary language found");
  return primaryLang;
});

export const primaryContentLanguageCodeSelector = createSelector(
  primaryContentLanguageSelector,
  (primaryLang) => primaryLang.code,
);
